export { default } from './getValidReactChildren';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/getValidReactChildren/index.js
// module id = 448
// module chunks = 25